import React from 'react';
import { Box, Typography } from '@mui/material';
import { DOMAIN_LABELS, FormattedChange } from 'domain/shared/newVacancy';
import ChangeItem from './ChangeItem';

interface ChangesGroupProps {
  domainName: string;
  changes: FormattedChange[];
}

const ChangesGroup: React.FC<ChangesGroupProps> = ({ domainName, changes }) => {
  const domainLabel = DOMAIN_LABELS[domainName] || domainName;

  if (changes.length === 1 && changes[0].property === 'updatedAt') {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle1" mb={1}>
        {domainLabel}:
      </Typography>

      <Box sx={{ ml: 2 }}>
        {changes.map(change => (
          <ChangeItem key={change.id} change={change} showDomainHeader={false} />
        ))}
      </Box>
    </Box>
  );
};

export default ChangesGroup;
